/**
 * @license GPL-3.0-only
 *
 * @author Mark Mayes / mm-dev
 *
 *
 * @module PD/IMAGE_IDS
 *
 * @description
 * ## Internal ID constants
 */


export const MAIN_TITLE = "imgMainTitle";

export const IMG_FONT_SPRITESHEET_3x5 = "imgFontSpritesheet3x5";
//export const IMG_FONT_SPRITESHEET_6x10 = "imgFontSpritesheet6x10";
//export const IMG_FONT_SPRITESHEET_12x20 = "imgFontSpritesheet12x20";
//export const IMG_FONT_SPRITESHEET_24x40 = "imgFontSpritesheet24x40";

export const IMG_FONT_SPRITESHEET_5x5 = "imgFontSpritesheet5x5";
//export const IMG_FONT_SPRITESHEET_10x10 = "imgFontSpritesheet10x10";
//export const IMG_FONT_SPRITESHEET_20x20 = "imgFontSpritesheet20x20";

export const IMG_FONT_SPRITESHEET_3x3 = "imgFontSpritesheet3x3";
//export const IMG_FONT_SPRITESHEET_6x6 = "imgFontSpritesheet6x6";
//export const IMG_FONT_SPRITESHEET_12x12 = "imgFontSpritesheet12x12";
//export const IMG_FONT_SPRITESHEET_24x24 = "imgFontSpritesheet24x24";

